import React, { Fragment } from "react";
import { UserContext } from "../Definitions/UserContext";
import { addtoCartEnum, utils } from "../../utils/Utils";
import $ from "jquery";
import ReactDom from "react-dom";
import StaffMessage from "../../Hooks/StaffMessage";
import CommonMessagepopup from "../../VagaroComponent/CommonMessagepopup";


export default function RenderBusinessMessage({ layout = "1", siteData }: { layout: string, siteData: UserContext }) {

    switch (layout) {
        default:
            return <MessageButtons siteData={siteData} />
    }


    function MessageButtons({ siteData }: { siteData: any }) {
        var IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;
        const BusinessData = utils.MultiLocationData(siteData, siteData.bidHash);
        if ((!IsEditor && BusinessData.showVagaroConnectMessagingInfo === 1) || IsEditor) {
            if (BusinessData.vagaroConnectBeta) {
                return <Fragment>
                    <a role="button" id="MessageControl" className="v-button center-all gap-med primary w-full sub-inherit-color" onClick={(event) => !IsEditor && (window as any).SendMessage(false, siteData, event)}><svg height="1em" fill="none" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"><path d="M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z" fill="currentColor"></path></svg> Message</a>
                </Fragment>
            } else {
                return <Fragment>
                    <a role="button" className="v-button center-all gap-med primary w-full sub-inherit-color" onClick={(event) => !IsEditor && (window as any).SendMessage(false, siteData)}><svg height="1em" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 128C0 93 28 64 64 64H448C483 64 512 93 512 128V384C512 420 483 448 448 448H64C28 448 0 420 0 384V128ZM32 128V168L227 312C244 324 267 324 284 312L480 168V128C480 111 465 96 448 96H63C46 96 31 111 31 128H32ZM32 208V384C32 402 46 416 64 416H448C465 416 480 402 480 384V208L303 338C275 358 236 358 208 338L32 208Z" fill="currentColor" /> </svg> Message</a>
                </Fragment>
            }
        }
        else{
            return <Fragment></Fragment>
        }
    }
}

declare global {
    interface Window { SendMessage: any; LoadCustomer: any; _vagaroConnect: any; }
}

window.SendMessage = function (staffMember: any, siteData: any, event: any) {
    const BusinessData = utils.MultiLocationData(siteData, siteData.bidHash);
    if (BusinessData.vagaroConnectBeta) {
        var IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;
        if (!IsEditor) {
            let LoginDetails = utils.ReadCookie();
            if (LoginDetails === undefined || LoginDetails === "" || LoginDetails === null) {
                window.wbc.openVagaroPage("divVagaroIframe", utils.VURL("Login", null) + addtoCartEnum.MessageControl + "&Data=" + event.currentTarget.id);
                return;
            } else {
                if (LoginDetails.cEncUid === undefined || LoginDetails.cEncUid === null || LoginDetails.cEncUid === "") {
                    return ReactDom.render(
                        <CommonMessagepopup
                            isConnectMessage={true}
                        />,
                        document.getElementById("OpenDialog1")
                    );
                }
                else {
                    <div id={"dvglbstyle"} style={{ display: "none" }}>
                        <button id="btnprimarybutton" className="v-button primary invisible-button"></button>
                        <button id="btnprimarybuttonhover" className="v-button-hover primary"></button>
                        <button id="btnsecondary" className="v-button secondary"></button>
                        <button id="btnsecondarybuttonhover" className="v-button-hover secondary"></button>
                        <div id="txtfontfamily" className="v-text"></div>
                        <button id="btnrating" className="v-filled-star"></button>
                        <button id="glbbackground" className="v-site"></button>
                        <h2 id="glbHeadingFont"></h2>
                    </div>
                    window._vagaroConnect.CustomerData(LoginDetails, siteData);
                    if (typeof window._vagaroConnect != "undefined") {
                        $('meta[name="viewport"]').attr('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0');
                        if (!window._vagaroConnect.model.isChatIframeLoaded) {
                            $(".wbloader").css("display", "block");
                            window._vagaroConnect.Init();
                        }
                        else if ($(window._vagaroConnect.controls.chatFrame).is(':visible') === false) {
                            window._vagaroConnect.ShowChatFrame(2);
                            $(".wbloader").css("display", "none");
                        }
                    }
                }
            }
        }
    }
    else {
        let LoginDetails = utils.ReadCookie();
        return ReactDom.render(
            <StaffMessage
                data={staffMember}
                LoginDetails={LoginDetails}
                siteData={siteData}
                isMessage={true}
            />,
            document.getElementById("OpenDialog")
        );
    }
};
